import { Tabs } from "devextreme-react";
import { useRef, useState } from "react";
import ReportByProject from "./ReportByProject";
import ReportList from "./ReportList";
import IndividualReport from "./IndividualReport";
import RawData from "./RawData";

export default function Report() {
  const [dataSource, setDataSource] = useState([
    {
      type: "report",
      text: "Report",
    },
    {
      type: "reportByProject",
      text: "Report by Project",
    },
    {
      type: "individualReport",
      text: "Individual Report",
    },
    {
      type: "data",
      text: "Data",
    },
  ]);

  const [cTab, setCTab] = useState("report");
  const [contrNo, setContrNo] = useState(null);

  const reportTabsRef = useRef(null);

  const itemRender = (e) => {
    return (
      <div
        style={{
          fontSize: "16px",
          fontWeight: "bold",
          color: "black",
          textTransform: "none",
        }}
      >
        {e.text}
      </div>
    );
  };

  const onItemClick = (e) => {
    setCTab(e.itemData.type);
  };

  return (
    <>
      <Tabs
        ref={reportTabsRef}
        dataSource={dataSource}
        defaultSelectedIndex={0}
        height={40}
        width={"auto"}
        // selectedItem={selectedItem}
        itemRender={itemRender}
        onItemClick={onItemClick}
      />
      <div style={{ height: "16px" }} />
      {cTab == "report" ? (
        <ReportList
          setCTab={setCTab}
          setContrNo={setContrNo}
          reportTabsRef={reportTabsRef}
        />
      ) : cTab == "reportByProject" ? (
        <ReportByProject contrNo={contrNo} setContrNo={setContrNo} />
      ) : cTab == "individualReport" ? (
        <IndividualReport />
      ) : (
        <RawData />
      )}
    </>
  );
}
